export const locale = {
  lang: 'de',
  data: {
    PRONOSTICO: {
      PRONOSTICO_SUCCESS: 'Erfolg',
      PRONOSTICO_ERROR: 'Fehler',
      PRONOSTICO_COMMUNICATION_ERROR: 'Kommunikationsfehler'
    }
  }
}
